import React, { useState } from 'react';
import Overview from '../components/Admin/Overview';
import UserManagement from '../components/Admin/UserManagement';
import RBAC from '../components/Admin/RBAC';
import AuditTrail from '../components/Admin/AuditTrail';
import SystemMonitoring from '../components/Admin/SystemMonitoring';
import BranchSync from '../components/Admin/BranchSync';
import { THEME } from '../constants/theme';

const Dashboard = () => {
    const [activeTab, setActiveTab] = useState('Overview');
    const user = JSON.parse(localStorage.getItem('user')) || { full_name: 'Admin', role: 'Super Admin' };

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = '/login';
    };

    const menuItems = [
        { id: 'Overview', label: 'Dashboard', icon: '📊' },
        { id: 'UserManagement', label: 'Staff Management', icon: '👥' },
       
       // { id: 'AuditTrail', label: 'Activity Logs', icon: '📝' },
        //{ id: 'Monitoring', label: 'System Health', icon: '⚡' },
        //{ id: 'BranchSync', label: 'Branch Sync', icon: '🌐' },
    ];

    return (
        <div style={styles.container}>
            {/* --- SIDEBAR --- */}
            <aside style={styles.sidebar}>
                <div style={styles.logoContainer}>
                    <div style={styles.logoIcon}>UM</div>
                    <div style={styles.logoText}>
                        <span style={{ fontWeight: '800', fontSize: '18px', color: '#fff' }}>
                            {THEME.footerCompany.toUpperCase()}
                        </span>
                        
                    </div>
                </div>

                <div style={styles.navHeader}>ADMINISTRATION</div>
                
                <nav style={{ flex: 1, padding: '0 10px' }}>
                    {menuItems.map((item) => (
                        <div
                            key={item.id}
                            onClick={() => setActiveTab(item.id)}
                            style={activeTab === item.id ? styles.activeNav : styles.navItem}
                        >
                            <span style={styles.iconSpan}>{item.icon}</span>
                            <span style={{ flex: 1 }}>{item.label}</span>
                            {activeTab === item.id && <div style={styles.activeDot} />}
                        </div>
                    ))}
                </nav>

                <div style={styles.sidebarFooter}>
                    <button onClick={handleLogout} style={styles.logoutBtn}>
                        <span style={{ marginRight: '10px' }}>🚪</span> Logout Session
                    </button>
                </div>
            </aside>

            {/* --- MAIN AREA --- */}
            <div style={styles.mainArea}>
                <header style={styles.header}>
                    <div>
                        <h2 style={styles.tabTitle}>{activeTab.replace(/([A-Z])/g, ' $1')}</h2>
                        <p style={styles.breadcrumb}>{THEME.footerCompany} / Control Panel / {activeTab}</p>
                    </div>
                    
                    <div style={styles.userProfile}>
                        <div style={{ textAlign: 'right' }}>
                            <span style={styles.userName}>{user.full_name}</span>
                            <span style={{...styles.userRole, color: THEME.secondary}}>{user.role}</span>
                        </div>
                        <div style={{...styles.avatar, border: `2px solid ${THEME.secondary}`, color: THEME.secondary}}>
                            {user.full_name.charAt(0)}
                        </div>
                    </div>
                </header>

                <section style={styles.content}>
                    {activeTab === 'Overview' && <Overview />}
                    {activeTab === 'UserManagement' && <UserManagement />}
                    {activeTab === 'RBAC' && <RBAC />}
                    {activeTab === 'AuditTrail' && <AuditTrail />}
                    {activeTab === 'Monitoring' && <SystemMonitoring />}
                    {activeTab === 'BranchSync' && <BranchSync />}
                </section>

                <footer style={styles.footer}>
                    <div>
                        © {THEME.year} <b>{THEME.footerCompany}</b>. {THEME.footerTagline}
                    </div>
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                        <span>Version: <b>{THEME.footerVersion}</b></span>
                        <span>
                            Status: <span style={{ color: THEME.success }}>● Online</span>
                        </span>
                    </div>
                </footer>
            </div>
        </div>
    );
};

const styles = {
    container: { display: 'flex', height: '100vh', backgroundColor: '#f8fafc', fontFamily: "'Inter', sans-serif" },
    
    // Sidebar Style (Same as Employee)
    sidebar: { 
        width: '280px', 
        backgroundColor: '#0f172a', 
        display: 'flex', 
        flexDirection: 'column', 
        boxShadow: '4px 0 10px rgba(0,0,0,0.1)'
    },
    logoContainer: { 
        padding: '30px 25px', 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px',
        borderBottom: '1px solid rgba(255,255,255,0.05)',
        marginBottom: '10px'
    },
    logoIcon: { 
        backgroundColor: THEME.secondary, 
        color: '#fff', 
        width: '40px', 
        height: '40px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        borderRadius: '10px', 
        fontWeight: 'bold',
        boxShadow: `0 4px 12px ${THEME.secondary}55`
    },
    logoText: { color: '#fff', letterSpacing: '1px' },
    navHeader: { padding: '20px 25px 10px', fontSize: '11px', fontWeight: 'bold', color: '#64748b', letterSpacing: '1.5px' },
    navItem: { 
        display: 'flex', 
        alignItems: 'center', 
        padding: '12px 15px', 
        color: '#94a3b8', 
        cursor: 'pointer', 
        borderRadius: '12px', 
        marginBottom: '6px',
        transition: 'all 0.3s ease',
        fontSize: '14px'
    },
    activeNav: { 
        display: 'flex', 
        alignItems: 'center', 
        padding: '12px 15px', 
        color: '#fff', 
        backgroundColor: THEME.secondary, 
        cursor: 'pointer', 
        borderRadius: '12px', 
        marginBottom: '6px',
        fontWeight: '600',
        boxShadow: `0 8px 15px ${THEME.secondary}33`,
        fontSize: '14px'
    },
    iconSpan: { marginRight: '12px', fontSize: '18px' },
    activeDot: { width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#fff' },
    
    sidebarFooter: { padding: '20px', borderTop: '1px solid rgba(255,255,255,0.05)', marginTop: 'auto' },
    logoutBtn: { 
        width: '100%', 
        padding: '12px', 
        backgroundColor: 'rgba(239, 68, 68, 0.1)', 
        color: '#ef4444', 
        border: 'none', 
        borderRadius: '10px', 
        cursor: 'pointer', 
        fontWeight: 'bold',
        transition: '0.3s'
    },

    // Main Area Style
    mainArea: { flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' },
    header: { 
        height: '85px', 
        backgroundColor: '#fff', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        padding: '0 40px', 
        boxShadow: '0 2px 10px rgba(0,0,0,0.03)' 
    },
    tabTitle: { margin: 0, fontSize: '22px', fontWeight: '700', color: '#1e293b' },
    breadcrumb: { margin: 0, fontSize: '12px', color: '#94a3b8', marginTop: '4px' },
    userProfile: { display: 'flex', alignItems: 'center', gap: '15px' },
    userName: { display: 'block', fontWeight: '700', fontSize: '15px', color: '#1e293b' },
    userRole: { fontSize: '11px', textTransform: 'uppercase', fontWeight: 'bold', display: 'block' },
    avatar: { 
        width: '45px', 
        height: '45px', 
        backgroundColor: '#f1f5f9', 
        borderRadius: '14px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        fontWeight: 'bold',
        fontSize: '18px'
    },
    content: { flex: 1, padding: '30px 40px', overflowY: 'auto', backgroundColor: '#f8fafc' },
    footer: { 
        height: '50px', 
        backgroundColor: '#fff', 
        borderTop: '1px solid #f1f5f9', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        padding: '0 40px', 
        fontSize: '12px', 
        color: '#64748b' 
    }
};

export default Dashboard;